<template>
    <modal
        name="share-watchlist-user-list"
        :width="600"
        height="auto"
        :pivot-y="0.3"
        :adaptive="true"
    >
        <div>
            <div class="share-watchlist-user-list__dialog-content">
                <span v-html="$t('Watchlist.modal_share_study_plan')"></span>
                <p class="share-watchlist-user-list__note-text">
                    <span class="share-watchlist-user-list__note-highlight" v-html="$t('Watchlist.modal_share_study_plan_note')"></span>
                    <span v-html="$t('Watchlist.modal_share_study_plan_note_text')"></span>
                </p>
            </div>
            <div class="share-watchlist-user-list__vue-dialog-buttons">
                <button
                    type="button"
                    @click="closeMenu"
                    class="share-watchlist-user-list__vue-dialog-button"
                >
                {{ $t('General.no') }}
                </button>
                <button
                    type="button"
                    @click="shareWatchListToAllSubordinates"
                    class="share-watchlist-user-list__vue-dialog-button"
                >
                    {{ $t('General.yes') }}
                </button>
            </div>
            <div class="share-watchlist-user-list__toggle-userlist" @click="showUserList = !showUserList">
                <span :class="{ active: showUserList }" class="icon-chevron-down"></span>
                <span v-html="getSubordinatesLength"></span>
            </div>
            <div v-if="showUserList" class="share-watchlist-user-list__userlist">
                <ShareWatchListTable
                    v-if="isDesktopView"
                    :isReadOnlyList="true"
                    :subordinates="subordinates"
                />
                <ShareWatchListTableMobile
                    v-if="isMobileView"
                    :isReadOnlyList="true"
                    :subordinates="subordinates"
                />
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapGetters } from 'vuex'
    import ShareWatchListTable from 'components/user/watchlist/sharewatchlist/selectusers/ShareWatchListTable'
    import ShareWatchListTableMobile from 'components/user/watchlist/sharewatchlist/selectusers/mobile/ShareWatchListTableMobile'

    export default {
        name: 'ShareWatchListUserListModal',
        components: {
            ShareWatchListTable,
            ShareWatchListTableMobile,
        },
        data () {
            return {
                showUserList: false
            }
        },
        computed: {
            ...mapGetters({
                subordinates: 'Watchlists/getSubordinates',
                userId: 'getUserId',
                selectedWatchList: 'Watchlists/getSelectedWatchList'
            }),
            getSubordinatesLength () {
                if (!this.subordinates) {
                    return false
                }
                return this.$t('WatchListModal.share_watchlist_show_list_of_users', { subordinates: '<span style="color:#e47700; font-weight: 600;">' + this.subordinates.length + '</span>' })
            }
        },
        methods: {
            closeMenu () {
                this.$modal.hide('share-watchlist-user-list')
                this.showUserList = false
            },
            shareWatchListToAllSubordinates () {
                this.$emit('shareWithAllSubordinatesAccepted')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .share-watchlist-user-list {
        font-family: Nunito-Regular, sans-serif;
        width: 100%;

        [class*="mobile"] & {
            padding: 10px;
        }
        &__bottom-functions {
            display: flex;
            justify-content: center;
            padding: 10px 0 0 0;
        }
        &__userlist {
            padding: 0 10px;
            top: 100%;
            position: relative;
            background: $white;
            z-index: 1;
            right: 0;
            width: 100%;
            overflow: unset !important;
        }
        &__toggle-userlist {
            padding: 10px;
            cursor: pointer;
            font-size: 1.4rem;
            display: flex;
            align-items: center;

            &:hover {
                cursor: pointer;
                @include black('background-color', 0.02);
            }
        }

        [class*="icon-"] {
            font-size: 1.7rem;
            margin: 0 5px;
            font-weight: 600;

            &.active {
                transform: rotate(-180deg);
            }
        }

        &__vue-dialog-button {
            font-size: 12px !important;
            background: transparent;
            padding: 0;
            margin: 0;
            border: 0;
            cursor: pointer;
            box-sizing: border-box;
            line-height: 40px;
            height: 40px;
            color: inherit;
            font: inherit;
            outline: none;
            flex: 1 1 33.3333%;
        }

        &__vue-dialog-button:not(:first-of-type) {
            border-left: 1px solid $bright_gray;
        }

        &__vue-dialog-button:hover {
            @include black('background-color', 0.01);
        }

        &__vue-dialog-buttons {
            display: flex;
            flex: 0 1 auto;
            width: 100%;
            border-top: 1px solid $bright_gray;
            border-bottom: 1px solid $bright_gray;
        }

        &__dialog-content {
            flex: 1 0 auto;
            width: 100%;
            padding: 15px;
            font-size: 14px;
        }

        &__note-text {
            margin: 10px 0;
        }

        &__note-highlight {
            font-family: Nunito-Bold, sans-serif;
        }
    }
</style>
